<template>
  <div class="monitor-empty h-full flex items-center justify-center">
    <div>
      <img src="@/assets/images/video-monitor/empty.png"/>
      <div class="text">暂无视频显示</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'monitorEmpty',
}
</script>

<style lang="scss" scoped>
.monitor-empty {
  .text {
    margin-top: 10px;
    text-align: center;
    color: var(--secondButtonDisabled);
    font-weight: 500;
  }
}
</style>
